"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogInfo = exports.LogError = void 0;
var _log = _interopRequireDefault(require("../../utils/log"));
var LogInfo = exports.LogInfo = function LogInfo() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  _log.default.info('perf日志: ', args);
};
var LogError = exports.LogError = function LogError() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  _log.default.warn("perf\u65E5\u5FD7: ".concat(typeof args === 'string' ? args : JSON.stringify(args)));
};